import { useState, useEffect, useContext } from 'react';
import {ErrorContext} from '../Contexts/ErrorContext'
import AlertMaintenanceAlerts from '../Services/AlertMaintenanceAlerts';
import {extractErrorMessage} from '../Services/RequestService';

export const useMaintenanceAlerts = (vehicleId) => {
    const [alerts, setAlerts] = useState([]);
    const token = localStorage.getItem("token");
    const {setError, success} = useContext(ErrorContext);

    const loadAll = async () => {
        try {
            const resp = vehicleId ? await AlertMaintenanceAlerts.allVehicleAlerts(vehicleId, token) : await AlertMaintenanceAlerts.allAlerts(token);
            setAlerts(resp.data);
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const addAlert = async (alert, storedVehicleId) => {
        try {
            await AlertMaintenanceAlerts.addAlert(alert, storedVehicleId ? storedVehicleId : vehicleId, token);
            await loadAll()
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const updateAlert = async (alert, alertId) => {
        try {
            await AlertMaintenanceAlerts.updateAlert(alert, alertId, token);
            await loadAll()
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const deleteAlert = async (alertId) => {
        try {
            await AlertMaintenanceAlerts.deleteAlert(alertId, token);
            await loadAll()
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    useEffect(() => {
        loadAll()
    }, []);

    return [alerts, addAlert, updateAlert, deleteAlert];
}


// WEBPACK FOOTER //
// ./src/Hooks/useMaintenanceAlerts.js